import React from 'react';
import styled from 'styled-components';
import AppRoutes from './AppRoutes';

const ContentPageWrapper = styled.div`
    padding: 35px 0;
    display: flex;
    max-width: 970px;
    margin-left: auto;
    margin-right: auto;
`

const ContentPage: React.FC<{}> = (props) => {
    return (
        <ContentPageWrapper>
            <AppRoutes />
        </ContentPageWrapper>
    )
}

export default ContentPage